import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { FrequentTravellerAviosCardsPage } from 'src/app/model/page/group/api-docs/frequent-traveller-avios-cards-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-frequent-traveller-avios-cards-page',
  templateUrl: './frequent-traveller-avios-cards-page.component.html',
  styleUrls: ['./frequent-traveller-avios-cards-page.component.scss']
})
export class FrequentTravellerAviosCardsPageComponent implements OnInit {
  frequentTravellerAviosPage: FrequentTravellerAviosCardsPage = {} as FrequentTravellerAviosCardsPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'fqtv-cards') {
        this.frequentTravellerAviosPage.htmlTitle = title.htmlTitle;
      }
    });
    this.frequentTravellerAviosPage.sections = [];
    this.frequentTravellerAviosPage.tableSections = [];

    const query = { 'fields.title': 'Frequent Traveller Avios Cards' };
    this.contentfulService.getPageContentResponse(query).then((FrequentTravellerAviosCardsPageEntries) => {
      this.mapBanner(FrequentTravellerAviosCardsPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.frequentTravellerAviosPage.banner);
      this.mapSections(FrequentTravellerAviosCardsPageEntries.includes.Entry);
      this.mapTableSection(FrequentTravellerAviosCardsPageEntries.includes.Entry);
      this.mapPageInfo(FrequentTravellerAviosCardsPageEntries.items);
    });
  }

  private mapBanner(frequentTravellerAviosPageEntries: Entry<any>[]) {
    frequentTravellerAviosPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.frequentTravellerAviosPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapSections(frequentTravellerAviosPageEntries: Entry<any>[]) {
    frequentTravellerAviosPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.frequentTravellerAviosPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();
    this.frequentTravellerAviosPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapTableSection(frequentTravellerAviosPageEntries: Entry<any>[]) {
    frequentTravellerAviosPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
        // // console.log(entry);
      });
    this.frequentTravellerAviosPage.tableSections.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    let givenTitle:any=entry.fields['title'] as string;
     let pageTitle=givenTitle.split('#')[2];
    this.frequentTravellerAviosPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string,
    });
    this.frequentTravellerAviosPage.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.frequentTravellerAviosPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.frequentTravellerAviosPage.banner.url = entry.fields?.url;
      this.frequentTravellerAviosPage.banner.editorEmail = editorDetails?.pop();
      this.frequentTravellerAviosPage.banner.editorShortName = editorDetails?.pop();
      this.frequentTravellerAviosPage.banner.editorFullName = editorDetails?.pop();
      this.frequentTravellerAviosPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
